var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-rating',{staticClass:"text-center my-3",attrs:{"dir":"ltr","background-color":_vm.backgroundColor,"color":_vm.color,"empty-icon":_vm.emptyIcon,"half-icon":_vm.halfIcon,"full-icon":_vm.fullIcon,"length":_vm.length,"size":_vm.size,"value":_vm.rate,"half-increments":"","readonly":"","hover":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }